import axios from "axios"

const axiosApi = axios.create({
	baseURL: process.env.REACT_APP_API_URL,
	headers: {
		'X-Requested-With': 'XMLHttpRequest',
		'Content-Type': 'application/json',
		'appversion': '1.1'
		// Authorization: localStorage.getItem('token')
	},
	responseType: 'json',
})



export async function get(url, config = {}) {
	axiosApi.defaults.headers.Authorization = localStorage.getItem('token');
	return await axiosApi.get(url, { ...config }).then(response => response.data).catch(error => error)
}

export async function post(url, data, config = {}) {
	try {
		axiosApi.defaults.headers.Authorization = localStorage.getItem('token');
		return axiosApi
			.post(url, { ...data }, { ...config })
			.then(response => response.data)
			.catch((error) => {
				if (error.response && error.response.status === 401) {
					window.location.href = '/logout';
				}
			})
	} catch (error) {
		console.log(error);
	}
}

export async function multipart_post(url, data) {
	try {
		return axios({
			url: process.env.REACT_APP_API_URL + url,
			method: 'POST',
			data: data,
			headers: {
				'Content-Type': 'multipart/form-data',
				'Authorization': localStorage.getItem('token')
			}
		})
			.then(response => response.data)
			.catch((error) => {
				if (error.response && error.response.status === 401) {
					window.location.href = '/logout';
				}
			})
	} catch (error) {
		console.log(error);
	}
}

export async function put(url, data, config = {}) {
	try {
		axiosApi.defaults.headers.Authorization = localStorage.getItem('token');
		return axiosApi
			.put(url, { ...data }, { ...config })
			.then(response => response.data)
			.catch((error) => {
				if (error.response && error.response.status === 401) {
					window.location.href = '/logout';
				}
			})
	} catch (error) {
		console.log(error);
	}
}

export async function del(url, config = {}) {
	try {
		axiosApi.defaults.headers.Authorization = localStorage.getItem('token');
		return await axiosApi
			.delete(url, { ...config })
			.then(response => response.data)
			.catch((error) => {
				if (error.response && error.response.status === 401) {
					window.location.href = '/logout';
				}
			})
	} catch (error) {
		console.log(error);
	}
}